import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById, getNCFileByName } from '@reducers/manufacture';
import { getProductionBatchByNCFile, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { getTools, close as clearTools } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useNCFileDetails } from '@v2/pages/common/hooks/useNCFileDetails';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import Times from '@v2/context/Times/page';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL_FOR_ITEM, SCREEN_PADDING_HORIZONTAL_FOR_PAGE } from '@v2/pages/common/constants/base.constants';

interface NCFileDetailsNCFileTimesProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const NCFileDetailsNCFileTimesComponent: FC<NCFileDetailsNCFileTimesProps> = ({
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  ncFileData,
  operationsSearch,
  getNCFileByName,
}) => {
  const title = useTitle();

  useNCFileDetails({
    clearTools,
    getNCFileById,
    getTools,
    getProductionBatchByNCFile,
    updateHeaderConfig,
    operationsSearch,
    getNCFileByName,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
        <Times
          withoutPaddingHorizontal
          ncFileId={ncFileData?.data?.ncFileId}
          style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL_FOR_ITEM) }}
          horizontalOffset={SCREEN_PADDING_HORIZONTAL_FOR_PAGE * 2}
        />
    </DetailsPageWrapper>
  );
};

const NCFileDetailsNCFileTimes = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getNCFileById,
  clearTools,
  getTools,
  getProductionBatchByNCFile,
  updateHeaderConfig,
  operationsSearch,
  getNCFileByName,
})(NCFileDetailsNCFileTimesComponent);

export { NCFileDetailsNCFileTimes };
